import React from 'react'
import { StyledIcon } from '../StyledIcon'
import { StyledIconPropsType } from './types'

const DocumentOutlineIcon = ({
  icon = "print-outline",
  color="plain",
  viewBox= "0 0 32 32",
  width = "32px",
  height = "32px",
  customProps,
} : StyledIconPropsType) => {
  return (
    <StyledIcon
      width={width}
      height={height}
      viewBox={viewBox}
      a11yTitle={icon}
      color={color}
      fill="none"
      {...customProps}
    >
        <path d="M18.6673 2.6665H8.00065C7.29341 2.6665 6.61513 2.94746 6.11503 3.44755C5.61494 3.94765 5.33398 4.62593 5.33398 5.33317V26.6665C5.33398 27.3737 5.61494 28.052 6.11503 28.5521C6.61513 29.0522 7.29341 29.3332 8.00065 29.3332H24.0007C24.7079 29.3332 25.3862 29.0522 25.8863 28.5521C26.3864 28.052 26.6673 27.3737 26.6673 26.6665V10.6665L18.6673 2.6665Z" stroke="#5E5E65" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M18.666 2.6665V10.6665H26.666" stroke="#5E5E65" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M21.3327 17.3335H10.666" stroke="#5E5E65" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M21.3327 22.6665H10.666" stroke="#5E5E65" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M13.3327 12H11.9993H10.666" stroke="#5E5E65" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>

    </StyledIcon>
  )
}

export default DocumentOutlineIcon